var _rect, _path, _ellipse, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 83,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 79 83)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.601 28.509C163.051 28.6737 163.05 29.326 162.601 29.4905C156.726 31.6413 154.641 33.7253 152.49 39.6008C152.326 40.0502 151.674 40.0504 151.509 39.601C149.357 33.7277 147.274 31.6438 141.399 29.491C140.949 29.3263 140.95 28.674 141.399 28.5095C147.274 26.3587 149.359 24.2747 151.51 18.3992C151.674 17.9498 152.326 17.9496 152.491 18.399C154.643 24.2723 156.726 26.3562 162.601 28.509Z",
    fill: "url(#paint0_linear_7320_91860)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 15.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 54.5 15.5)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.142 42H59.8563C55.7537 42 52.4277 45.3259 52.4277 49.4286V105.143C52.4277 109.246 55.7537 112.571 59.8563 112.571H134.142C138.245 112.571 141.571 109.246 141.571 105.143V49.4286C141.571 45.3259 138.245 42 134.142 42Z",
    stroke: "url(#paint1_linear_7320_91860)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.571 42.0011V30.8583C115.571 28.8881 114.788 26.9986 113.395 25.6054C112.002 24.2124 110.112 23.4297 108.142 23.4297H85.8563C83.8861 23.4297 81.9966 24.2124 80.6035 25.6054C79.2104 26.9986 78.4277 28.8881 78.4277 30.8583V42.0011",
    stroke: "url(#paint2_linear_7320_91860)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7320_91860",
    x1: 163.727,
    y1: 28.8033,
    x2: 124.531,
    y2: 41.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7320_91860",
    x1: 140.558,
    y1: 76.7072,
    x2: 3.29232,
    y2: 135.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7320_91860",
    x1: 115.149,
    y1: 32.5632,
    x2: 68.6759,
    y2: 63.8474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.39e69ef575202b7fa11cb007364fb2cb.svg";
export { ForwardRef as ReactComponent };